import script from "./ModalCreateMassPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCreateMassPayment.vue?vue&type=script&setup=true&lang=js"

import "./ModalCreateMassPayment.vue?vue&type=style&index=0&id=6f742a58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f742a58"]])

export default __exports__